import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Injector,
  Input,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PresentationalAtomsModule } from '@et/presentational/atoms';
import { EtjournalPacketEntry } from '@et/typings';
import { EjournalService } from '../../services/ejournal.service';
import { JournalPacketAddEditComponent } from '../journal-packet-add-edit/journal-packet-add-edit.component';

@Component({
  selector: 'et-journal-packet-card-wrapper',
  imports: [PresentationalAtomsModule],
  templateUrl: './journal-packet-card-wrapper.component.html',
  styleUrl: './journal-packet-card-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JournalPacketCardWrapperComponent {
  @Input() eJournal: EtjournalPacketEntry | null = null;

  readonly isFinalizing = signal<boolean>(false);
  readonly validationErrors = signal<string[]>([]);

  @ViewChild('finalizeEJournalModal')
  finalizeEJournalModal!: TemplateRef<unknown>;

  @ViewChild('validationErrorsModal')
  validationErrorsModal!: TemplateRef<unknown>;

  private dialog = inject(MatDialog);
  private ejournalService = inject(EjournalService);
  private injector = inject(Injector);

  isPacketSigned = computed(
    () => this.ejournalService.selectedPacket()?.utcDateSigned !== null,
  );

  notarizedAuditLoaded = this.ejournalService.notarizedAuditLoaded;

  /**
   * Opens the edit eJournal packet dialog for the currently selected packet.
   */
  onEditEJournal() {
    const packet = this.ejournalService.selectedPacket()!;
    const profile = this.ejournalService.profile()!;
    const eJournal = this.ejournalService.eJournal()!;

    this.dialog.open(JournalPacketAddEditComponent, {
      injector: this.injector,
      panelClass: ['et-dialog-radius', 'et-dialog-padding'],
      autoFocus: false,
      width: '100%',
      maxWidth: '800px',
      data: { packet, profile, eJournal },
    });
  }
}
